import { createSlice } from '@reduxjs/toolkit';

import { fetchUserProfile, updateUserProfile } from './profile.actions';

const initialState = {
  profile: {},
  isLoadingProfile: false,
  isUpdatingProfile: false
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearProfileState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserProfile.pending, (state) => {
      state.isLoadingProfile = true;
    });
    builder.addCase(fetchUserProfile.fulfilled, (state, action) => {
      state.profile = action.payload?.data || {};
      state.isLoadingProfile = false;
    });
    builder.addCase(fetchUserProfile.rejected, (state) => {
      state.isLoadingProfile = false;
    });

    builder.addCase(updateUserProfile.pending, (state) => {
      state.isUpdatingProfile = true;
    });
    builder.addCase(updateUserProfile.fulfilled, (state, action) => {
      state.profile = action.payload?.data || state.profile;
      state.isUpdatingProfile = false;
    });
    builder.addCase(updateUserProfile.rejected, (state) => {
      state.isUpdatingProfile = false;
    });
  }
});

export const { clearProfileState } = profileSlice.actions;

export default profileSlice.reducer;
